import configureStore from 'redux/store/configureStore';

export const reduxStore = configureStore();
